module.exports = __webpack_public_path__ + "img/VikingLogo.097da07e.png";